import { ProductsCampaignManagementAPIClient } from '@studyportals/campaign-management-api-interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import { LoadingStatuses } from '@/models/loading.interface';
import { CampaignFeaturesForTracking } from '@/models/tracking.interface';
import cookieHandler from '@/infrastructure/cookie-handler';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';
import redshiftTracker from '@/infrastructure/redshift-tracker';

class PricingProductsPresenter {
	private client: ProductsCampaignManagementAPIClient;
	private readonly tokenId: string;

	constructor() {
		this.client = new ProductsCampaignManagementAPIClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
	}

	public async retrieveProducts(): Promise<void> {
		store.mutations.setLoadingStatusPricingProducts(LoadingStatuses.ACTIVE);

		let wasSuccessful = false;
		try {
			const products = await this.client.getAllProducts(this.tokenId);
			store.mutations.setAllPricingProducts(products.products);
			store.mutations.setLoadingStatusPricingProducts(LoadingStatuses.INACTIVE);
			wasSuccessful = true;
		} catch (e) {
			rollbarOperator.triggerError(e as Error);
			store.mutations.setModalErrorState(ModalErrorStates.GET_PRICING_PRODUCTS);
			store.mutations.setLoadingStatusPricingProducts(LoadingStatuses.FAILURE);
		} finally {
			redshiftTracker.trackProcessOutcome(CampaignFeaturesForTracking.PRICING_PRODUCTS, false, wasSuccessful);
		}
	}
}

export default new PricingProductsPresenter();
